import Vue from 'vue'
import Component from 'vue-class-component'
import { FREEMIUM_EXIT_POPUP } from '@/plugins/feature-flags/flags'
import ExitModal from '~/components/common/modals/exit-modal/ExitModal.vue'

@Component
export default class ExitModalMixin extends Vue {
  get isExitPopupAllowed() {
    const allowedFsets = ['FreemiumPaywall', 'FreemiumTrial']
    const { isFreemium } = this.$accessor.account
    const fset = this.$accessor.featureSet.name
    const isCorrectFset = allowedFsets.includes(fset)
    const isFeatureEnabled = this.$featureFlags?.isEnabled(FREEMIUM_EXIT_POPUP)
    return !isFreemium && isCorrectFset && isFeatureEnabled
  }

  showExitModal() {
    this.$modal.show(ExitModal, null, {
      height: 'auto',
      adaptive: true,
      width: this.$accessor.screen.isMobile
        ? `${this.$accessor.screen.resolution - 32}px`
        : '638px'
    })

    const exitModalOpenEvent = this.$mixpanel.events.FREEMIUM_PAYWALL_POPUP_OPEN
    const exitModalOpenEventProps = this.$mixpanel.fillProps(exitModalOpenEvent)
    this.$mixpanel.track(exitModalOpenEvent, exitModalOpenEventProps)
  }
}
